import { apiClient } from "../../../../../api/client";
import { ApiResponse } from "../../../../../types";
import {
  ApproveDocumentParams,
  DocumentApprovalParams,
  DocumentForApproval,
} from "../types";

export const documentApprovalService = {
  async getDocumentsForApproval(
    params: DocumentApprovalParams
  ): Promise<ApiResponse<DocumentForApproval[]>> {
    return apiClient.post("/gestorCadastroDocList", params);
  },

  async approveDocument(
    params: ApproveDocumentParams
  ): Promise<ApiResponse<any>> {
    return apiClient.post("/gestorCadastroDocApproval", params);
  },

  async rejectDocument(
    params: ApproveDocumentParams
  ): Promise<ApiResponse<any>> {
    return apiClient.post("/gestorCadastroDocReject", params);
  },

  async sendToAzumi(
    params: DocumentApprovalParams
  ): Promise<ApiResponse<any>> {
    return apiClient.post("/gestorCadastroAzumi", params);
  },
};
